var youbora = require('youboralib')
require('./adapter')
// require('./register-plugin')
module.exports = youbora



//////////////////
// WEBPACK FOOTER
// ./src/sp.js
// module id = 51
// module chunks = 0